import React from "react";
import SettingsContainer from "../../../../../components/theme/settings";
import FormGroup from "../../../../../components/theme/form-group/FormGroup";
import EmailAliases from "../../../../../components/pickers/email-aliases/EmailAliases";
import { PropertiesByTrigger } from "./useGeneralSettingsProperties";
import { WorkflowTriggerType, WorkspaceEvent } from "../../../../../__generated__/api";
import GeneralDetailsDescription from "./GeneralDetailsDescription";
import Select from "../../../../../components/select/Select";
import ChannelTags from "../../../../../components/pickers/channel-tags/ChannelTags";

function formatEventLabel(eventTypeId: string) {
    return eventTypeId.replace("urn:fq:workspace-event-type:", "").replaceAll("-", " ").capitalize();
}

export default function BaseGeneralSettings(
    { properties, workspaceEvents }:
    {
        properties: PropertiesByTrigger<WorkflowTriggerType>,
        workspaceEvents: WorkspaceEvent[],
    },
) {
    return (
        <SettingsContainer navigation="none">
            <SettingsContainer.Section title="General">
                <SettingsContainer.Setting
                    title="Name"
                    description="The name of the email."
                    permissions={[]}
                >
                    <FormGroup
                        type="text"
                        placeholder="Email Name"
                        onChange={evt => properties.name.setValue(evt.target.value)}
                        value={properties.name.value}
                    />
                </SettingsContainer.Setting>
                <SettingsContainer.Setting
                    title="Description"
                    description="The description of the email."
                    permissions={[]}
                >
                    <GeneralDetailsDescription properties={properties} />
                </SettingsContainer.Setting>

                {"channelTags" in properties && (
                    <SettingsContainer.Setting
                        title="Trigger Channels"
                        description="Choose which channels or channel groups can trigger the automation when the selected emoji is added to a message. Leave empty if you want the emoji to work in all channels."
                        permissions={[]}
                    >
                        <ChannelTags
                            isMulti
                            value={properties.channelTags.value.map(tag => tag.value)}
                            onSelected={values => {
                                properties.channelTags.setValue(values.map(id => ({
                                    label: id,
                                    value: id,
                                })));
                            }}
                        />
                    </SettingsContainer.Setting>
                )}

                {"emails" in properties && (
                    <SettingsContainer.Setting
                        title="Emails"
                        description="Select one or more email aliases."
                        permissions={[]}
                    >
                        <EmailAliases
                            isMulti
                            value={properties.emails.value}
                            onSelected={properties.emails.setValue}
                        />
                    </SettingsContainer.Setting>
                )}
                {"event" in properties && (
                    <SettingsContainer.Setting
                        title="Events"
                        description="Select one or more events."
                        permissions={[]}
                    >
                        <Select
                            value={properties.event.value ? {
                                label: formatEventLabel(properties.event.value),
                                value: properties.event.value,
                            } : null}
                            options={workspaceEvents.map(event => ({
                                label: formatEventLabel(event.eventTypeId),
                                value: event.eventTypeId,
                            }))}
                            onChange={value => properties.event.setValue(value.value)}
                            isClearable
                        />
                    </SettingsContainer.Setting>
                )}
            </SettingsContainer.Section>
        </SettingsContainer>
    );
}
